import React from "react";
import { ScanResultType } from "../../types/ScanResultType";
import { useBarcodeReader } from "../../hooks/useBarcodeReader";
import HoneywellScannerPagePresentation from "./HoneywellScannerPagePresentation";
import { handleScanResult } from "../../helpers/handleScanResultUtils";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { SymbologyType } from "../../types/SymbologyType";
import { useDefaultScannerBehavior } from "../../hooks/useDefaultScannerBehavior";

const ScannerPage: React.FC = () => {
  const navigate = useFixaNavigate();
  const { navigateToSearch, error, setError, taskType, readyToScanText } =
    useDefaultScannerBehavior();

  useBarcodeReader((data, type) => {
    const scanResult: ScanResultType = {
      scannedBarcode: data,
      symbologyFormat: type as SymbologyType,
    };
    handleScanResult(scanResult, taskType, navigate);
  });
  return (
    <HoneywellScannerPagePresentation
      error={error}
      setError={setError}
      readyToScanText={readyToScanText}
      scannerType="honeywell"
      taskType={taskType}
      pushSearch={navigateToSearch}
    />
  );
};

export default ScannerPage;
